module.exports = __webpack_public_path__ + "static/media/phone.f45b6887.svg";